import { Button } from 'antd';
import { observer } from 'mobx-react';
import React, { useState } from 'react';

import type DocumentFolder from 'stores/DocumentFolder';

import AddProjectModal from './AddProjectModal';

export interface AddProjectButtonProps {
  parentDocument: DocumentFolder;
}

function AddProjectButton({ parentDocument }: AddProjectButtonProps) {
  const [isModalVisible, setIsModalVisible] = useState(false);

  return (
    <>
      <Button
        disabled={!parentDocument.canEdit}
        onClick={() => setIsModalVisible(true)}
      >
        Add Project
      </Button>

      {parentDocument.canEdit && (
        <AddProjectModal
          isVisible={isModalVisible}
          onClose={() => setIsModalVisible(false)}
          parentDocument={parentDocument}
        />
      )}
    </>
  );
}

export default observer(AddProjectButton);
